<template>
  <div>
    <modal
      v-show="updateLoanAccountModal"
      @close="cloaseUpdateLoanAccountModal"
      footer
      modalIsLarge
    >
      <template v-slot:title>
        <h5>View Loan - {{ loan_data.other_reference }}</h5>
      </template>
      <template v-slot:body>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <label for="title">CBA Loan Account Number</label>
              <input
                type="text"
                class="form-control"
                name="title"
                v-model="loan_data.loan_cba_reference"
              />
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <button
          class="btn btn-success text-white"
          @click.prevent="updateLoanApplication"
          :disabled="update_loan_loading"
        >
          <span class="custom-loader" v-if="update_loan_loading">
            <loader-icon size="1.5x" class="custom-class"></loader-icon>
            <span style="font-weight: 600; text-transform: initial;"
              >Updating CBA Loan Amount...</span
            >
          </span>
          <span v-else>
            Update Loan Account
          </span>
        </button>
        <button @click.prevent="closeCreateModal" class="btn btn-secondary">
          Cancel
        </button>
      </template>
    </modal>
    <div class="row">
      <div class="col-md-12">
        <div class="card p-2">
          <div class="card-content">
            <div class="card body p-md-3 p-2">
              <CDataTable :items="loanProducts" :fields="fields" sorter>
                <template #action="{ item }">
                  <td>
                    <router-link
                      v-if="permissions.includes('view-other-loan')"
                      :to="{
                        name: 'ViewOtherLoanDetail',
                        params: { slug: item.reference }
                      }"
                      class="btn btn-sm btn-primary"
                      >View</router-link
                    >
                  </td>
                </template>
                <template #accounts="{ item }">
                  <td>
                    <b><strong>Account No:</strong> {{ item.account_number }}</b> <hr>
                    <b v-if="item.core_banking_loan_reference"><strong>Loan Account No:</strong>{{ item.core_banking_loan_reference }}</b> 
                  </td>
                </template>
                <template #amount_breakdown="{ item }">
                  <td>
                    <b><strong>Amount Requested:</strong>{{ item.amount_requested }}</b> <hr>
                    <b><strong>Amount Approved:</strong> {{ item.amount_approved }}</b> 
                  </td>
                </template>
                <template #balance_breakdown="{ item }">
                  <td>
                    <b><strong>Total Balance:</strong> {{ item.total_amount }}</b> <hr>
                    <b v-if="item.cba_principal_balance"><strong>Principal Balance:</strong> {{ item.cba_principal_balance }}</b>
                  </td>
                </template>
                <template #booked_by="{ item }">
                  <td v-if="item.create_by_user">
                    <b>
                      {{
                        `${item.create_by_user.first_name} ${item.create_by_user.last_name}`
                      }}</b
                    ><br>
                    <span class="badge"
                    :class="{
                      'badge-success': item.source === 'admin',
                      'badge-success': item.source === 'admin-cba',
                      'badge-primary': item.source === 'app'
                    }"
                    >
                      {{ item.source }}
                    </span>
                  </td>
                  <td v-else-if="item.user">
                    <b>
                      {{ `${item.user.first_name} ${item.user.last_name}` }}</b
                    >
                  </td>
                  <td v-else>
                    <b>-</b>
                  </td>
                </template>
              </CDataTable>
              <CPagination
                :activePage.sync="next_page"
                :pages="total ? total : 1"
                :onActivePageChange="onPageChange()"
              >
              </CPagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueDataTable from "@/components/VueDataTable";
import CCard from "@/components/CCard";
import CModal from "@/components/CModal";
import CDataTable from "@/components/CDataTable.vue";
import ApiService from "@/services/api.service";
import CPagination from "@/components/CPagination.vue";
const fields = [
  "booked_by",
  "account_name",
  "accounts",
  "amount_breakdown",
  "balance_breakdown",
  "approval_status",
  "loan_status",
  "due_date",
  "created_date",
  "action"
];

export default {
  name: "LoanTable",
  components: {
    VueDataTable,
    CCard,
    CModal,
    CDataTable,
    CPagination
  },
  props: {
    loanProducts: {
      default: []
    },
    current: {
      default: 1
    },
    total: {
      default: 1
    },
    onPageChangeAction: {
      type: Function
    }
  },
  computed: {
    permissions() {
      let permissions = this.$store.getters.permissions;
      return permissions;
    },
    // ...mapGetters(["reportsLoading"]),
    removeCommaFromAmount() {
      return this.loan_amount.toString().replace(/,/g, "");
    }
  },
  data() {
    return {
      fields,
      loanProductsLoading: true,
      end_date: "",
      start_date: "",
      customer_id: "",
      loan_product: "",
      next_page: 1,
      reference: "",
      phone: "",
      ref: "",
      status: "",
      reportsLoading: true,
      kpiObj: null,
      kpiLoading: false,
      loan_data: {
        loan_cba_reference: "",
        other_loan_id: "",
        other_reference: ""
      },
      updateLoanAccountModal: false,
      update_loan_loading: false,
    };
  },
  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    onPageChange() {
      if (this.current != this.next_page) {
        this.$emit("onPageChangeAction", this.next_page);
      }
    },
    showUpdateLoanAccountModal(data) {
      this.updateLoanAccountModal = true;
      this.loan_data.loan_cba_reference = data.loan_cba_reference;
      this.loan_data.other_loan_id = data.id;
      this.loan_data.other_reference = data.reference;
    },
    cloaseUpdateLoanAccountModal() {
      this.updateLoanAccountModal = false;
      this.loan_data.loan_cba_reference = "";
      this.loan_data.other_loan_id = "";
      this.loan_data.other_reference = "";
    },
  },
  mounted() {
    // this.allProductLoan(1);
    // this.kpiStats();
  }
};
</script>
